import { List } from '@melements/front-components';
import React, { ChangeEvent, Fragment, useContext, useState } from 'react';
import { Loader, LocaleContext, PageHeader } from 'shared';

import { useQuery } from '../../../shared/hooks';
import { Report } from '../../../store/api/reports/reports.types';
import { PageWrapper, SearchInput, SearchInputWrapper } from '../Dashboard.styles';

import { ReportsWrapper } from './Reports.styles';
import { ReportsProps } from './Reports.types';
import { COLUMNS } from './table/Table.columns';

export const Reports = ({ onFetchReports }: ReportsProps) => {
  const localeContext = useContext(LocaleContext);
  const [search, setSearch] = useState('');
  const { response, error, loading } = useQuery(onFetchReports);

  const formatDataForTable = (reportList: Report[] | null) => {
    if (!loading && reportList) {
      let counter = 0;

      return reportList.map(report => {
        counter = counter + 1;

        return {
          action: onFetchReports,
          creationDate: formatDateTime(report.creationDate),
          fileName: report.fileName,
          id: counter.toString(),
        };
      });
    }

    return [];
  };

  const filteredReports = (reportList: Report[]) => {
    if (reportList) {
      return formatDataForTable(reportList).filter((report: Report) => {
        return (
          report.fileName.toLowerCase().includes(search.toLowerCase()) ||
          report.creationDate.toLowerCase().includes(search.toLowerCase())
        );
      });
    }

    return [];
  };

  const formatDateTime = (dateTimeString: string) => {
    return new Date(dateTimeString).toLocaleString('pl');
  };

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return (
    <PageWrapper className="reports">
      <PageHeader>
        {localeContext.formatMessage({ id: 'DASHBOARD.HEADER.REPORTS' })}
        <SearchInputWrapper>
          <SearchInput
            placeholder={localeContext.formatMessage({ id: 'GENERAL.SEARCH' })}
            value={search}
            onChange={handleSearch}
            className="reports__search"
          />
        </SearchInputWrapper>
      </PageHeader>

      {loading && <Loader />}
      {response && response.payload && !error && (
        <ReportsWrapper className="reports">
          <List
            columns={COLUMNS}
            data={filteredReports(response.payload)}
            placeholder={<Fragment>{localeContext.formatMessage({ id: 'REPORTS.TABLE.PLACEHOLDER' })}</Fragment>}
            loading={false}
          />
        </ReportsWrapper>
      )}
    </PageWrapper>
  );
};
